/* Utilitaires SVG natifs — pas de librairie externe */

export interface Point { x: number; y: number }

export function normalizePoints(data: number[], w: number, h: number, pad = 2): Point[] {
  if (data.length === 0) return []
  const min = Math.min(...data)
  const max = Math.max(...data)
  const range = max - min || 1
  const step = data.length > 1 ? (w - pad * 2) / (data.length - 1) : 0
  return data.map((v, i) => ({
    x: pad + i * step,
    y: pad + (1 - (v - min) / range) * (h - pad * 2),
  }))
}

export function toPolyline(points: Point[]): string {
  return points.map((p) => `${p.x.toFixed(1)},${p.y.toFixed(1)}`).join(' ')
}

export function toLinePath(points: Point[]): string {
  if (points.length === 0) return ''
  return points
    .map((p, i) => `${i === 0 ? 'M' : 'L'}${p.x.toFixed(1)},${p.y.toFixed(1)}`)
    .join(' ')
}

export function toAreaPath(points: Point[], h: number): string {
  if (points.length === 0) return ''
  const line = toLinePath(points)
  const last = points[points.length - 1]!
  const first = points[0]!
  return `${line} L${last.x.toFixed(1)},${h} L${first.x.toFixed(1)},${h} Z`
}

/* Calcule une courbe de Bézier lissée */
export function toSmoothPath(points: Point[]): string {
  if (points.length < 2) return toLinePath(points)
  let d = `M${points[0]!.x.toFixed(1)},${points[0]!.y.toFixed(1)}`
  for (let i = 1; i < points.length; i++) {
    const prev = points[i - 1]!
    const curr = points[i]!
    const cpx = (prev.x + curr.x) / 2
    d += ` C${cpx.toFixed(1)},${prev.y.toFixed(1)} ${cpx.toFixed(1)},${curr.y.toFixed(1)} ${curr.x.toFixed(1)},${curr.y.toFixed(1)}`
  }
  return d
}

export function toSmoothAreaPath(points: Point[], h: number): string {
  if (points.length === 0) return ''
  const smooth = toSmoothPath(points)
  const last = points[points.length - 1]!
  const first = points[0]!
  return `${smooth} L${last.x.toFixed(1)},${h} L${first.x.toFixed(1)},${h} Z`
}
